import { Component } from '@angular/core';
import { AccessoryCreateService } from 'src/app/core/services/accessory-create.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-accessories',
  templateUrl: './accessories.component.html',
  styleUrl: './accessories.component.scss'
})
export class AccessoriesComponent {

showAddAccessoryModal = false;
showEditAccessoryModal = false;
showAddAccessoryFab = true;
savedAccessories: any[] = [];

constructor(private accessoryCreateService: AccessoryCreateService) {}

accessoryToEdit: any = {
  accessoryName: '',
  accessoryType: '',
  model: '',
  detail: '',
  serialNumber: ''
};

accessoryTypes = ['Cushion', 'Headgear', 'Mask', 'Breathing Circuit'];

accessoryData: { [key: string]: { models: string[]; details:  { [key: string]: string }[] } } = {
  "Cushion": {
    "models": [
      "Amara Cushion",
      "Amara Gel Cushion",
      "ComfortGel Cushion",
      "DreamWear Cushion",
      "DreamWear Full Cushion",
      "DreamWear Gel Cushion"
    ],
    "details": [
      {"name": "Petite", "value": "Petite"},
      {"name": "Small", "value": "Small"},
      {"name": "Medium", "value": "Medium"},
      {"name": "Large", "value": "Large"}
    ]
  },
  "Headgear": {
    "models": [
      "Amara Headgear",
      "Amara View Headgear",
      "DreamWear Frame",
      "DreamWear Full Headgear",
      "DreamWear Headgear"
    ],
    "details": [
      {"name": "Small", "value": "Small"},
      {"name": "Medium", "value": "Medium"},
      {"name": "Large", "value": "Large"}
    ]
  },
  "Mask": {
    "models": [
      "Amara Silicone",
      "Amara View",
      "Comfort Classic",
      "Comfort Full",
      "Comfort Fusion"
    ],
    "details": [
      {"name": "Petite", "value": "Petite"},
      {"name": "Small", "value": "Small"},
      {"name": "Medium", "value": "Medium"},
      {"name": "Large", "value": "Large"}
    ]
  },
  "Breathing Circuit": {
    "models": ["Active", "Adapter", "Passive"],
    "details": [
      {"name": "Adult with heated wire", "value": "awhw"},
      {"name": "Pediatric with heated wire", "value": "pwhw"},
      {"name": "Pediatric with water trap", "value": "pwwt"}
    ]
  }
};

getModelsForType(type: string) {
  return this.accessoryData[type]?.models || [];
}

getDetailsForType(type: string) {
  return this.accessoryData[type]?.details || [];
}

addAccessory() {
  this.showAddAccessoryModal = true;
}

openAddAccessoryModal() {
  this.accessoryToEdit = {};
  this.showAddAccessoryModal = true;
}

closeAddAccessoryModal() {
  this.showAddAccessoryModal = false;
}

openEditAccessoryModal(accessory: any) {
  this.accessoryToEdit = { ...accessory };
  this.showEditAccessoryModal = true;
}

closeEditAccessoryModal() {
  this.showEditAccessoryModal = false;
}

saveNewAccessory() {
  console.log('Accessory data from UI:', this.accessoryToEdit); // debug
  this.accessoryCreateService
    .createAccessory(this.accessoryToEdit.displayName, this.appendRandomPostfix("dsn-"), this.accessoryToEdit.accessoryType.replace(' ', ''), this.accessoryToEdit.detail)
    .subscribe({
      next: (response) => {
        console.log('Accessory saved successfully:', response);
        this.savedAccessories.push(this.accessoryToEdit);
        this.closeAddAccessoryModal();
      },
      error: (err) => {
        console.error('Error saving accessory:', err);
      }
    });
}

appendRandomPostfix(base: string): string {
  const randomNum = Math.floor(Math.random() * 10000); // generates 0–9999
  return `${base}${randomNum}`;
}

saveAccessoryEdit() {
  console.log('Accessory updated:', this.accessoryToEdit);
  this.closeEditAccessoryModal();
}


}
